import { CSSProperties, FC, PropsWithChildren } from 'react';

import { TColorProp } from 'styled-components';

import { inter, satoshi } from '~/common/styles/fonts';

import { Container, TDocsSize } from './styles';

interface IDocsProps extends PropsWithChildren {
  size: TDocsSize;
  color?: TColorProp;
  style?: CSSProperties;
  href?: string;
}

export const Docs: FC<IDocsProps> = ({
  size,
  color = 'neutral.100',
  children,
  style,
  href,
}) => {
  return (
    <Container
      $size={size}
      $color={color}
      className={size === 'paragraph' ? inter.className : satoshi.className}
      style={style}
      {...(href && {
        as: 'a',
        href,
      })}
    >
      {children}
    </Container>
  );
};
